// extracted by mini-css-extract-plugin
export default {"admin_employees_content":"Employees_admin_employees_content__BtpXX","employees_stats_table_actions":"Employees_employees_stats_table_actions__fwL1y"};